<script lang="ts">
  import { contentComponentFactory } from "$lib/content/contentComponentFactory";
  import EmptyContent from "./components/EmptyContent.svelte";
  import type { Content } from "$lib/elev8Api/contentTypes";
  import { quadInOut } from "svelte/easing";
  import { slide } from "svelte/transition";

  const defaultContent: Content = {
    content_type: "empty",
    id: "",
  };

  interface Props {
    content?: Content;
    [key: string]: unknown;
  }

  let { content = defaultContent, ...restProps }: Props = $props();

  let ContentComponent = $derived(
    contentComponentFactory.getComponent(content)
  );

  const transition = (node: Element) =>
    slide(node, { easing: quadInOut, axis: "y" });
</script>

{#if ContentComponent !== EmptyContent}
  {#key content.id}
    <div transition:transition class="content-renderer">
      <ContentComponent {content} {...restProps} />
    </div>
  {/key}
{/if}

<style>
  .content-renderer {
    width: 100%;
    height: 100%;
  }
</style>
